export const SET_DERBY_PERMISSION_PENDING = 'SET_DERBY_PERMISSION_PENDING';
export const SET_DERBY_PERMISSION_SUCCESS = 'SET_DERBY_PERMISSION_SUCCESS';
export const SET_DERBY_PERMISSION_ERROR = 'SET_DERBY_PERMISSION_ERROR';
